import axios from 'axios';
import {
  StockTransfer,
  StockTransferStatusEnum,
} from '../models/StockTransfer';
import { Warehouse } from '../../stock/models/StockLine';

const API_URL = `${process.env.REACT_APP_API_URL}/api/stock-transfers/`;

type ListStockTransfersParams = {
  status?: StockTransferStatusEnum;
  warehouse?: Warehouse;
};

export function listStockTransfers({
  status,
  warehouse,
}: ListStockTransfersParams = {}): Promise<{ data: StockTransfer[] }> {
  const params = {
    status,
    warehouse,
  };
  return axios.get(API_URL, { params });
}

export function receiveStockTransfer(
  id: number
): Promise<{ data: StockTransfer }> {
  const endpoint = `${API_URL}${id}/receive/`;
  return axios.post(endpoint);
}

export function deleteStockTransfer(id: number): Promise<void> {
  const endpoint = `${API_URL}${id}/`;
  return axios.delete(endpoint);
}

export function uploadStockTransfersExcel(
  file: File,
  warehouseId: number
): Promise<{ data: StockTransfer[] }> {
  const endpoint = `${API_URL}upload-excel/`;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('warehouse_id', warehouseId.toString());
  return axios.post(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
